import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { CommunityFeedItemLikeBtnComponent } from './likes/community-feed-item-like-btn/community-feed-item-like-btn.component';
import { CommunityFeedItemLikeCountComponent } from './likes/community-feed-item-like-count/community-feed-item-like-count.component';
import { CommunityFeedItemHideComponent } from './hide/community-feed-item-hide.component';
import { CommunityFeedItemFlagComponent } from './flag/community-feed-item-flag.component';
import { CommunityFeedItemSubscribeComponent } from './subscribe/community-feed-item-subscribe.component';
import { CommunityArchiveBtnComponent } from './archive/community-archive-btn.component';
import { CommunityFollowBtnComponent } from './follow/community-follow-btn.component';
import { NumToKPipe } from '../../pipes/num-to-k';
import { DynamicTooltipComponent } from '../dynamic-tooltip/dynamic-tooltip.component';
import { UserTooltipComponent } from '../dynamic-tooltip/user-tooltip.component';
import { SharedModule } from '../../shared/shared.module';
import { CommonComponentsModule } from '../components/common-components.module';
import { CommentSectionComponent } from './comment-section/comment-section.component';
import { CommentSectionShortComponent } from './comment-section-short/comment-section-short.component';
import { UtEditorModule } from '../ut-editor/ut-editor.module';
import { UserCardComponent } from '../components/user-card/user-card.component';
import { EmojiTextPipe } from '../../pipes/emoji-text.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule,
    CommonComponentsModule,
    SharedModule,
    UtEditorModule,
    EmojiTextPipe,
  ],
  declarations: [
    CommunityFeedItemLikeBtnComponent,
    CommunityFeedItemLikeCountComponent,
    CommunityFeedItemHideComponent,
    CommunityFeedItemFlagComponent,
    CommunityFeedItemSubscribeComponent,
    CommunityArchiveBtnComponent,
    CommunityFollowBtnComponent,
    DynamicTooltipComponent,
    UserTooltipComponent,
    NumToKPipe,
    CommentSectionComponent,
    CommentSectionShortComponent,
    UserCardComponent,
  ],
  exports: [
    CommunityFeedItemLikeBtnComponent,
    CommunityFeedItemLikeCountComponent,
    CommunityFeedItemHideComponent,
    CommunityFeedItemFlagComponent,
    CommunityFeedItemSubscribeComponent,
    CommunityArchiveBtnComponent,
    CommunityFollowBtnComponent,
    DynamicTooltipComponent,
    UserTooltipComponent,
    CommentSectionComponent,
    CommentSectionShortComponent,
    UserCardComponent,
    NumToKPipe,
  ],
})
class CommunityModule {}

export { CommunityModule };
